import { IRequestService } from "../../service/request/RequestService";
import { IRequestType } from "../../model/request/RequestType";

export default class CreateRequestTypeInteractor {
  private requestService: IRequestService;

  constructor(requestService) {
    this.requestService = requestService;
  }

  async execute(requestType: IRequestType) {
    return this.requestService.createRequestType(requestType);
  }
}
